import asyncActionType from "../../utils/asyncActionType";

export const FETCH_MARKET_ORDERS = asyncActionType("FETCH_MARKET_ORDERS");
export const FETCH_MARKET_ORDER_DETAIL = asyncActionType("FETCH_MARKET_ORDER_DETAIL");
export const CREATE_ORDER = asyncActionType("CREATE_ORDER");
export const FETCH_MARKET_ORDER_DUPLICATE = asyncActionType("FETCH_MARKET_ORDER_DUPLICATE");
export const FETCH_BACK_ORDER_DETAIL = asyncActionType("FETCH_BACK_ORDER_DETAIL");
export const CLEAR_BACK_ORDER_DETAIL = "CLEAR_BACK_ORDER_DETAIL";
export const CHANGE_ORDER_ITEM_BACK_ORDER = "CHANGE_ORDER_ITEM_BACK_ORDER";
export const CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER = "CHANGE_ORDER_ITEM_COMPLETED_NOT_BACK_ORDER";
